import {
  activeRecentlyModifiedFieldsState,
  isFieldRecentlyModified,
} from '@/states/recently-modified-products.state';
import { useAtomValue } from 'jotai';

/**
 * Hook to check if a specific field of a product is recently modified.
 * @param productId - The product ID to check
 * @param field - The field name to check
 * @returns true if the field was recently modified
 */
export function useIsFieldRecentlyModified(
  productId: string,
  field: string
): boolean {
  const activeFields = useAtomValue(activeRecentlyModifiedFieldsState);
  return isFieldRecentlyModified(activeFields, productId, field);
}
